import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Checkbox,
  Badge,
  Image,
  Radio
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { addNotification } from '../../../redux/actions/emailManagerActions';
import { getCountry, getCountryCity } from '../../../redux/actions/countryCityActions';
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
 import DateTimeRangePicker from '@wojtekmaj/react-datetimerange-picker';
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import '@wojtekmaj/react-datetimerange-picker/dist/DateTimeRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {

};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class AddNotification extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'ADD_NOTIFICATION',
      path: ["Home", "Notification"],
      links: ["home", "notification/add"],
      date: new Date(),
      disabled: false,
      country: '',
      countryName: '',
      local: true,
      city: '',
      cityID: '',
      alertMessage: '',
      show: '',
      msgType:'',
      message: '',
      status: 'live',
      started_at: '',
      ended_at: '',
      display_image: '',
      remove_image: 1,
      mobileapp_display_image: '',
      remove_mobile_app_image: 1,
      display_image_link: '',
      include_in_site: true,
      include_in_email: false,
      previewMobileImage: '',
      previewImage: '',
      position: 'top',
      french_message: '',
      multi_lang: 'no',
      typeName:1,
      adsPath:'',
      adsHeight:'',
      adsWidth:'',
      adsID:'',
      scripttype:'',
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  onChangeStartDateRange = date => {
    this.setState({ startDateRange: date, startDateRangeError: '' })
  };
  

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });

    if(e.target.name == 'countryName' && e.target.value != ''){
      isLoading = "true";
      this.props.getCountryCity(e.target.value);
    }
  }

  validate = () => {
    let isError = false;
    if(!this.state.countryName){
      isError = true;
      this.setState({countryNameError: 'red'});
    }

    if(this.state.local == false && this.state.cityID == ''){
      isError = true;
      this.setState({cityIDError: 'red'});
    }

    if(!this.state.startDateRange){
      isError = true;
      this.setState({startDateRangeError: 'red'});
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      isLoading = "true";

      let dateRange = this.state.startDateRange;
      const formData = new FormData();
      formData.append("display_image", (this.state.display_image[0]) ? this.state.display_image[0] : '');
      formData.append("mobileapp_display_image", (this.state.mobileapp_display_image[0]) ? this.state.mobileapp_display_image[0] : '');
			formData.append("countryName", this.state.countryName); 
			formData.append("local", (this.state.local) ? 'yes' : 'no');
			formData.append("city_id", this.state.cityID);
			formData.append("message", this.state.message);
			formData.append("started_at", moment(dateRange[0]).format('YYYY-MM-DD HH:mm:ss'));
      formData.append("ended_at", moment(dateRange[1]).format('YYYY-MM-DD HH:mm:ss'));
			formData.append("status", this.state.status);
			formData.append("remove_image", this.state.remove_image);
			formData.append("remove_mobile_app_image", this.state.remove_mobile_app_image);
			formData.append("display_image_link", this.state.display_image_link);
			formData.append("include_in_site", (this.state.include_in_site) ? 0 : 1);
			formData.append("include_in_email", (this.state.include_in_email)  ? 0 : 1);
      formData.append("position", this.state.position);
      formData.append("french_message", this.state.french_message);
      formData.append("typeName", this.state.typeName);
      formData.append("adsPath", this.state.adsPath);
      formData.append("scripttype", this.state.scripttype);
      formData.append("adsHeight", this.state.adsHeight);
      formData.append("adsWidth", this.state.adsWidth);
      formData.append("adsID", this.state.adsID);
			this.props.addNotification(formData, 'notifications/add');
    }
  }

  Clear = () => {
    
  };

  handlePageChange = page => {};

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getCountry();
  }
  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.notification !== nextProps.notification) {
      if (nextProps.notification) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.notification.message);
        isLoading = "false";
        window.scrollTo(0, 0);
        this.setState({
          countryName: '',
          typeName:'',
          local: true,
          cityID: '',
          status: 'live',
          started_at: '',
          message:'',
          ended_at: '',
          display_image: '',
          remove_image: 1,
          mobileapp_display_image: '',
          remove_mobile_app_image: 1,
          display_image_link: '',
          include_in_site: true,
          include_in_email: false,
          previewMobileImage: '',
          previewImage: '',
          startDateRange: '',
          french_message: '',
          typeName:1,
          adsPath:'',
          adsHeight:'',
          adsWidth:'',
          adsID:'',
          scripttype:'',
        });
        // this.clear();
      }
    }

    if (this.props.country !== nextProps.country){
      if(nextProps.country){
        isLoading = "false";
        this.setState({country: nextProps.country});
      }
    }

    if (this.props.city !== nextProps.city){
      if(nextProps.city){
        isLoading = "false";
        this.setState({city: nextProps.city});
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  manageLocation = (e) => {
  	if(e.target.checked){
      this.setState({local: true});
  	}else{
  		this.setState({local: false});
  	}
  }

  includeSite = (e) => {
  	if(e.target.checked){
  		this.setState({include_in_site: true});
  	}else{
  		this.setState({include_in_site: false});
  	}
  }

  includeEmail = (e) => {
  	if(e.target.checked){
  		this.setState({include_in_email: true});
  	}else{
  		this.setState({include_in_email: false});
  	}
  }

  uploadOption(id) {
    document.getElementById(id).click();
  }

  handleFormData = (e) => {
    let files = e.target.files;
    this.setState({ display_image: e.target.files });
    if(e.target.files){
    this.setState({ previewImage: URL.createObjectURL(e.target.files[0])});
    }
  }

  handleMobileFormData = (e) => {
    let files = e.target.files;
    this.setState({ mobileapp_display_image: e.target.files });
    if(e.target.files){
    this.setState({ previewMobileImage: URL.createObjectURL(e.target.files[0])});
  	}
  }

  removeImage = (item) => {
  	if(item == 'mobile'){
  		this.setState({mobileapp_display_image: '', previewMobileImage: '', remove_mobile_app_image: 0});
  	}else{
  		this.setState({display_image: '', previewImage: '', remove_image: 0});
  	}
  }

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form>
          <div className="panel">
            <header className="panel-heading">Add Notification</header>
            <div className="panel-body">
              {this.state.show && this.state.alertMessage !=='' &&  
              <Row>      
                <div className="col-lg-12">
                  <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
                </div>
              </Row>
              }
              <Row>
              	<Col md={3} xs={12}>
              	  <FormGroup controlId="formCountry">
	                  <ControlLabel>Country</ControlLabel>
	                  <FormControl componentClass="select" name="countryName" value={this.state.countryName} placeholder="select" onChange={this.handleChange} style={{borderColor:this.state.countryNameError}}>
							        <option value="">Select Country</option>
                      {(this.state.country) &&
                        this.state.country.map((data, index) => 
                        <option value={data.country}>{data.countryName}</option>
                        )
                      }
							      </FormControl>
						      </FormGroup>
                </Col>
                <Col md={3} xs={12}>
              	  <FormGroup controlId="formCity">
	                  <ControlLabel><Checkbox inline name="local" defaultChecked={this.state.local} onClick={this.manageLocation}>All Local Markets</Checkbox></ControlLabel>
	                  {(this.state.local == false) &&	
	                  <FormControl componentClass="select" style={{borderColor:this.state.cityIDError}} name="cityID" value={this.state.cityID} placeholder="select" onChange={this.handleChange}>
							        <option value="">Select City</option>
                      {(this.state.city) &&
                        this.state.city.map((data, index) => 
                        <option value={data.cityID}>{data.title}</option>
                        )
                      }
							      </FormControl>
							      }
			     				</FormGroup>
                </Col>
                <Col md={6} xs={12}>
              	  <FormGroup controlId="formSchedule">
	                  <ControlLabel>Schedule Date & Time</ControlLabel><br/>
	                  <DateTimeRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                        className={(this.state.startDateRangeError) ? "error" : ""}
                      />
			      			</FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup controlId="formCity">
                    <ControlLabel>Content Type</ControlLabel>
                    <FormControl componentClass="select" name="typeName" value={this.state.typeName} placeholder="select" onChange={this.handleChange} style={{borderColor:this.state.typeNameError}}>
                      <option value="1">Message</option>
                      <option value="2">Ads Script</option> 
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
	              <Col md={12} xs={12}>
	              	<FormGroup controlId="formMessage">
		                <ControlLabel>Message Or Script</ControlLabel>
	              			<FormControl
	                      value={
	                        this.state.message
	                      }
	                      componentClass="textarea"
	                      onChange={this.handleChange}
	                      name="message"
	                      rows={5}
                        style={{borderColor:this.state.messageError}}
	                    />
	                </FormGroup>
	              </Col>
              </Row>
              {(this.state.multi_lang == "yes") &&
              <Row>
                <Col md={12} xs={12}>
                  <FormGroup controlId="formMessage">
                    <ControlLabel>Message Or Script (Canadian French)</ControlLabel>
                      <FormControl
                        value={
                          this.state.french_message
                        }
                        componentClass="textarea"
                        onChange={this.handleChange}
                        name="french_message"
                        rows={5}
                      />
                  </FormGroup>
                </Col>
              </Row>
              }
              {this.state.typeName==2 && 
                <React.Fragment>
                  <Row>
                    <Col md={12} xs={12}>
                      <Radio 
                        id={Math.random()} 
                        name="scripttype" 
                        inline 
                        value="google"
                        checked={this.state.scripttype=='google' ? true : false}
                        onChange={this.handleChange}
                      > 
                        Google Script 
                      </Radio>
                      <Radio 
                        id={Math.random()} 
                        name="scripttype" 
                        inline 
                        value="other"
                        checked={this.state.scripttype=='other' ? true : false}
                        onChange={this.handleChange}
                      > 
                        Other Script
                      </Radio>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3} xs={12}>
                      <FormGroup controlId="formImageLink">
                        <ControlLabel>Path</ControlLabel>
                          <FormControl
                            value={
                              this.state.adsPath
                            }
                            type="text"
                            onChange={this.handleChange}
                            name="adsPath"
                          />
                      </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                      <FormGroup controlId="formImageLink">
                        <ControlLabel>Ads Height</ControlLabel>
                          <FormControl
                            value={
                              this.state.adsHeight
                            }
                            type="text"
                            onChange={this.handleChange}
                            name="adsHeight"
                          />
                      </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                      <FormGroup controlId="formImageLink">
                        <ControlLabel>Ads Width</ControlLabel>
                          <FormControl
                            value={
                              this.state.adsWidth
                            }
                            type="text"
                            onChange={this.handleChange}
                            name="adsWidth"
                          />
                      </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                      <FormGroup controlId="formImageLink">
                        <ControlLabel>Ads ID</ControlLabel>
                          <FormControl
                            value={
                              this.state.adsID
                            }
                            type="text"
                            onChange={this.handleChange}
                            name="adsID"
                          />
                      </FormGroup>
                    </Col>
                  </Row>
                </React.Fragment>
              }
              <Row>
	              <Col md={4} xs={12}>
	              	<FormGroup controlId="formImageLink">
		                <ControlLabel>Display Image Link</ControlLabel>
	              			<FormControl
	                      value={
	                        this.state.display_image_link
	                      }
	                      type="text"
	                      onChange={this.handleChange}
	                      name="display_image_link"
	                    />
	                </FormGroup>
	              </Col>
                <Col md={4} xs={12}>
                  <FormGroup controlId="formPosition">
                    <ControlLabel>Position</ControlLabel>
                    <FormControl componentClass="select" name="position" value={this.state.position} placeholder="select" onChange={this.handleChange}>
                      <option value="top">Top</option>
                      <option value="third_position">3rd Offer Position</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                  <FormGroup controlId="formStatus">
                    <ControlLabel>Status</ControlLabel>
                    <FormControl componentClass="select" name="status" value={this.state.status} placeholder="select" onChange={this.handleChange}>
                      <option value="live">Live</option>
                      <option value="inactive">Inactive</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                </Row>
                <Row>
	              <Col md={12} xs={12}>
	              <FormGroup>
						      <Checkbox name="include_in_site" defaultChecked={this.state.include_in_site} inline onClick={this.includeSite}>Include Notification on site</Checkbox> <Checkbox name="include_in_email"  defaultChecked={this.state.include_in_email} inline onClick={this.includeEmail}>Include Notification in daily deal email</Checkbox>
						    </FormGroup>
	              </Col>
              </Row>
              <Row>
              	<Col md={3} xs={6} className="text-center">
	              	<FormGroup>
		                <ControlLabel>Display Image</ControlLabel>
	              			<FormControl
					              type="file"
					              id="image"
					              style={{ display: "none" }}
					              multiple
					              onChange={this.handleFormData}
					            />
					            {(this.state.previewImage) ?
					            <Col md={12} xs={12}>
                          <Image
                          	key="preview"
                            src={this.state.previewImage}
                            width="100%"
                            thumbnail
                          />
                          <Badge
                            bsStyle="danger"
                            style={{
                              top: "-6%",
                              position: "absolute",
                              right: "3%"
                            }}
                            className="cursor"
                            onClick={this.removeImage.bind(this, 'preview')}
                          >
                            <i className="glyphicon glyphicon-remove" />
                          </Badge>
                      </Col>
                      :
					            <h1 className="cursor" onClick={this.uploadOption.bind(this, 'image')}><i className="glyphicon glyphicon-cloud-upload"></i></h1>
					            }
                      <span style={{fontSize:'12px', color:'#666'}}>(Valid image formats include JPG, GIF and PNG. Optimum sizes: 960px X 90px.)</span>
	                </FormGroup>
	              </Col>
	              <Col md={3} xs={6} className="text-center">
	              	<FormGroup>
		                <ControlLabel>Mobile app display Image</ControlLabel>
	              			<FormControl
					              type="file"
					              id="mobile_image"
					              style={{ display: "none" }}
					              multiple
					              onChange={this.handleMobileFormData}
					            />
					            {(this.state.previewMobileImage) ?
					            <Col md={12} xs={12}>
                          <Image
                          	key="mobile"
                            src={this.state.previewMobileImage}
                            width="100%"
                            thumbnail
                          />
                          <Badge
                            bsStyle="danger"
                            style={{
                              top: "-6%",
                              position: "absolute",
                              right: "3%"
                            }}
                            className="cursor"
                            onClick={this.removeImage.bind(this, 'mobile')}
                          >
                            <i className="glyphicon glyphicon-remove" />
                          </Badge>
                      </Col>
                      :
					            <h1 className="cursor" onClick={this.uploadOption.bind(this, 'mobile_image')}><i className="glyphicon glyphicon-cloud-upload"></i></h1>
	                		}
                      <span style={{fontSize:'12px', color:'#666'}}>(Valid image formats include JPG, GIF and PNG. Optimum sizes: 480px X 80px for banner)</span>
	                </FormGroup>
	              </Col>
              </Row>
              <Row className="margin-top">
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    onClick={this.handleSubmit}
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  <Button
                    bsStyle="default"
                    id="cancelButton"
                    onClick={() => this.context.router.history.push('/notification/list')}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    notification: state.emailManagerReducer.notification,
    error: state.emailManagerReducer.error,
    country: state.countryCityReducers.countries,
    city: state.countryCityReducers.countryCity,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    addNotification,
    getCountry,
    getCountryCity,
  })
)(AddNotification);


// WEBPACK FOOTER //
// ./src/app/views/admin/notification/AddNotification.js